__turbopack_context__.v({
  "billImage": "_1b6CDG_billImage",
  "rotate": "_1b6CDG_rotate",
  "toTheSide": "_1b6CDG_toTheSide",
  "waiting": "_1b6CDG_waiting",
});
